import {
  getArrayFromLocalStorage,
  reduceArrayToMatchMaxLength
} from "@dealer-center/core-components";
import { useLocalStorageKeys } from "@dealer-center/core-interfaces-components";
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AccountHistoryState {
  accountHistory: string[];
  addToAccountHistory: (accountId: string) => void;
  removeFromAccountHistory: (accountId: string) => void;
}
const key = useLocalStorageKeys.ddcAccountHistory;

export const useAccountHistory = create<AccountHistoryState>()(
  persist(
    (set, get) => ({
      accountHistory: getArrayFromLocalStorage<string>(key),
      addToAccountHistory: (accountId: string) => {
        set(state => {
          const existingListWithoutItem = state.accountHistory.filter(
            id => id !== accountId
          );
          const itemsToSet = reduceArrayToMatchMaxLength(
            [accountId, ...existingListWithoutItem],
            key
          );
          return { accountHistory: itemsToSet };
        });
      },
      removeFromAccountHistory: (accountId: string) => {
        set(state => {
          const existingListWithoutItem = state.accountHistory.filter(
            id => id !== accountId
          );
          return { accountHistory: existingListWithoutItem };
        });
      }
    }),
    {
      name: key
    }
  )
);
